import React, { Component } from "react";
import { connect } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import { helperFunctions as HF} from 'helper/helperFunctions';
import Select from 'react-select';
import { Button } from "react-bootstrap";
import MessageCom from "layouts/Dashboard/Message";
import CKEditor from "react-ckeditor-component";

class TranscribeFormPage extends Component {
	constructor(props){
    	super(props);
    	this.validator = new SimpleReactValidator();
    	const { commentObject } = this.props;
    	console.log('commentObject', commentObject);
    	this.state = {
    		commentObject : commentObject,
    		submitted : false,
    		flagTestEmail : false,
    	}
    	this.onChange   =  this.onChange.bind(this);
    	this.submitForm = this.submitForm.bind(this);
    	this.handleChangeRole = this.handleChangeRole.bind(this);
    	this.onChangeCK = this.onChangeCK.bind(this);
    	this.handleChangeTemplate = this.handleChangeTemplate.bind(this);
	}

	flagForTestEmail = (e) => {
		const { checked } = e.target;
		this.setState({flagTestEmail:checked}, ()=>{
			if (!checked){
				this.setState({commentObject:{...this.state.commentObject, testEmail:''}})
			}
		})
	}
	handleChangeTemplate(selectedOptionType, info){
		if (info['action'] === 'select-option') {
			this.setState({commentObject:this.props.commentObjects[selectedOptionType['count']]})
		}
	}

	onChange(e){
		const { name, value, type } = e.target;
	    const commentObjectState = { ...this.state.commentObject };
	    commentObjectState[name] = type === 'checkbox' ? e.target.checked ? 1 : 0 : value;
	    this.setState({commentObject: commentObjectState});
	}
	submitForm(e, updateAndSend){
	    e.preventDefault();
	    if (this.validator.allValid()) {
			this.setState({submitted: true}, function(){
				this.props.handleCommentSubmit(this.state.commentObject, this.props.formType);
			});
		} else {
			this.setState({submitted: false});
			this.validator.showMessages();
			this.forceUpdate();
		}
	}
	handleChangeRole(selectedOptionType, info){
		if (info['action'] === 'select-option') {
			const commentObjectDropDown = { ...this.state.commentObject };
			commentObjectDropDown['id'] = selectedOptionType['value'];
			this.setState({ commentObject: commentObjectDropDown });
		}
	}
	onChangeCK(evt){
      var newContent = evt.editor.getData();
	  const commentObjectState = { ...this.state.commentObject };
	  commentObjectState['comment_text'] = newContent;
	  this.setState({commentObject: commentObjectState});
    }
	render(){
		this.validator.purgeFields();
		const { commentObject  } = this.state;
		const { formType, buttonName } = this.props;
		return(
			<div className="content">
				{/* <div className="play" durationtest={durationAudio[key]} position={pos[key]}>
					{
						!playing[key] &&
						<button onClick={()=>this.handleTogglePlay(key)} test={prop.comment_url}><img src={play} alt="playImage" /></button>
					}
					{
						playing[key] &&
						<button onClick={()=>this.handleTogglePlay(key)} test={prop.comment_url}><img src={pause} alt="pauseImage" /></button>
					}
				</div> */}
				
				<form  id="email-template-form">
										
			        <div className="form-group">
			        	<label>Comments</label>
			          	
			          	<CKEditor 
				        	activeClass="p10" 
				          	content={commentObject.comment_text} 
				          	events={{
				            	"change": this.onChangeCK,
				          	}}
				        />
			          	{this.validator.message('comment_text', commentObject.comment_text, 'required')}
			        </div>

			        {
			        	( formType !== 'generate' ) &&
			        	<React.Fragment>
					        <div className="form-group">
					        	<label className="container-check">
					        	<input type="checkbox" className="form-control" value={commentObject.is_text_approved} onChange={this.onChange} name="is_text_approved" checked={commentObject.is_text_approved?true:false}/>
					        	<span className="checkmark"></span>
					        	Approved For Director</label>
					          	{
					          		this.validator.message('is_text_approved', commentObject.is_text_approved, 'required')
					          	}
					        </div>
				        </React.Fragment>
			        }
					
				    <div className="text-center">
				    	<Button onClick={(e)=>this.submitForm(e, 0)} form="email-template-form" className="backButton pt-sm no_radius pb-sm success btn btn-lg btn-info ml-sm mt-sm" >{ buttonName }</Button>
					</div>
					<div className="row">
				    	<div className="col-md-12">
				      		<div>
				        		<MessageCom/>
				      		</div>
				    	</div>
				  	</div>
				</form>
			</div>
		);
	};
}


function mapStateToProps(state) {
    const { adminType } = state.adminReducer;
    return {
        adminType
    };
}

const TranscribeForm = connect(mapStateToProps)(TranscribeFormPage);
export default TranscribeForm;



// WEBPACK FOOTER //
// ./src/components/Admin/TranscribeForm.jsx